import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, filter, take } from 'rxjs/operators';
import { StdLotSizeService } from '@cemex-core/cmx-api';
import {
  OneClickStandardLotActionTypes,
  OneClickLoadStandardLotAction,
  OneClickLoadStandardLotCompleteAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-standard-lot-actions';
import { PRODUCT_LINE_CODE } from '@ordersnproducts/modules/shared/constants/product-lines-codes';
import {
  OneClickJobsiteSalesAreaActionTypes,
  OneClickLoadJobsiteSalesAreaCompleteAction,
} from '../actions/one-click-jobsite-sales-area.actions';
import { State } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { getOneClickSelectedOrder } from '../selectors/one-click-orders.selector';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { MultipleStdLotSizeRes } from '@cemex-core/cmx-api/models/std-lot-size/multiple-std-lot-size-res';

@Injectable()
export class OneClickStandardLotEffects {
  loadStandardLotCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickJobsiteSalesAreaActionTypes.LOAD_JOBSITE_SALES_AREA_COMPLETE),
      switchMap((action: OneClickLoadJobsiteSalesAreaCompleteAction) =>
        this.store.select(getOneClickSelectedOrder).pipe(
          take(1),
          map((state) => {
            return new OneClickLoadStandardLotAction(state, action.payload);
          }),
        ),
      ),
    ),
  );

  getMultipleStdLotSize = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickStandardLotActionTypes.LOAD_STANDARD_LOT),
      map((action: OneClickLoadStandardLotAction) => action),
      filter((action) => !!action),
      switchMap((action) => {
        const request = {
          jobsiteId: action.payload.jobsite.jobsiteId,
          productLineCode: action.payload.items[0].product.productType.productTypeCode as PRODUCT_LINE_CODE,
          salesAreaId: _safe(() => action.salesArea[0].salesArea.salesAreaId),
        };

        if (action.payload.pointOfDelivery && action.payload.pointOfDelivery.pointOfDeliveryId) {
          request['pointOfDeliveryId'] = action.payload.pointOfDelivery.pointOfDeliveryId;
        }

        return this.stdLotSizeService.getMultipleStdLotSize(request).pipe(
          map((response: MultipleStdLotSizeRes) => {
            return new OneClickLoadStandardLotCompleteAction(response);
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private stdLotSizeService: StdLotSizeService,
    private store: Store<State>,
  ) {}
}
